import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Shield } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, {
        withCredentials: true,
      });
      toast.success('Logged out successfully');
      navigate('/admin-login');
    } catch (error) {
      console.error('Logout failed:', error);
      toast.error('Logout failed');
    }
  };

  return (
    <nav className="glass-effect border-b border-zinc-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary flex items-center justify-center font-heading font-black text-xl">
              M
            </div>
            <span className="font-heading font-black text-2xl tracking-tight">
              MSF <span className="text-primary">ADMIN</span>
            </span>
          </div>

          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2 px-4 py-2 bg-primary/10 border border-primary/30">
              <Shield className="text-primary" size={18} />
              <span className="text-sm font-bold text-primary">ADMIN MODE</span>
            </div>
            <button
              onClick={handleLogout}
              data-testid="admin-logout-button"
              className="text-zinc-400 hover:text-primary transition-colors flex items-center space-x-2"
            >
              <LogOut size={20} />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
